(function (angular) {
  var controllerId = "termsController";
  angular
    .module("app")
    .controller(controllerId, ["$scope", "$location", "UserProvider", "alkAuthenticationService",
      function ($scope, $location, UserProvider, alkAuthenticationService) {
        //todo: take out dependency on $http, should have service for this stuff. probably userservice or some other service for user functions related to the account - get user, accept terms, change password, forgot password, etc.
        $scope.acceptTerms = function () {
          $scope.isProcessing = true;

          alkAuthenticationService
            .acceptTerms()
            .then(() => {
              UserProvider.getUser().currentTermsOfUseAccepted = true;

              if ($location.search().path) {
                $location.url($location.search().path);
              } else {
                $location.url("/app");
              }
            }, () => {
              // only set the processing back to false in case of error.  In success we are switching pages which may take a second.  Don't want the user to think that the click didn't work.
              $scope.isProcessing = false;
            });
        };
      }
    ]);
})(window.angular);



// WEBPACK FOOTER //
// ./app/account/terms.controller.js